import type { ProductFilters, WooCommerceProduct } from "@/types/woocommerce";
import { searchParamsToFilters } from "@/lib/filterQuery";
import { ProductDetailClient } from "./ProductDetailClient";
import fs from "node:fs/promises";
import path from "node:path";

export async function generateStaticParams() {
  const filePath = path.join(process.cwd(), "public", "products.json");
  const json = await fs.readFile(filePath, "utf8");
  const products: WooCommerceProduct[] = JSON.parse(json);

  return products.map((p) => ({ id: p.id.toString() }));
}

type PageProps = {
  params: { id: string };
  searchParams: Record<string, string | string[] | undefined>;
};

export default function ProductDetailPage({ params, searchParams }: PageProps) {
  const spLike = {
    get(name: string): string | null {
      const value = searchParams?.[name];
      if (Array.isArray(value)) return value[0] ?? null;
      return value ?? null;
    },
  };

  const filters: ProductFilters = searchParamsToFilters(spLike);

  return <ProductDetailClient filters={filters} />;
}

